<template>
    <div class="container">
        <h6 class="font-weight-bold" v-html="TEXTS.render(`PAYMENT_SECTION_HEADER`)"></h6>
        <div class="row">
            <div class="col-lg-6">
                <form>
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="formGroupExampleInput" class="font-weight-bold" v-html="TEXTS.render(`PAYMENT_SECTION_NAME_HEADER`)"></label>
                                <input type="text" class="form-control" id="inputName" :placeholder="TEXTS.render(`PAYMENT_SECTION_NAME_PLACEHOLDER`)" v-model="paymentDetails.name" @keyup="validateField('name')">
                                <div class="mt-1 text-danger font-weight-bold" v-html="validations.name.error" />
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <div class="d-flex justify-content-between">
                                    <label for="formGroupExampleInput2" class="font-weight-bold" v-html="TEXTS.render(`PAYMENT_SECTION_CARD_NUMBER_HEADER`)"></label>
                                    <div class="d-block mb-1">
                                        <img :src="mainURL + '/img/creditcard/mastercard.png'" class="cc-icon__small pr-1">
                                        <img :src="mainURL + '/img/creditcard/visa.png'" class="cc-icon__small">
                                        <!-- <img :src="mainURL + 'img/creditcard/american-express.png'" class="cc-icon__small pr-1"> -->
                                        <img :src="mainURL + '/img/creditcard/diners-club.png'" class="cc-icon__small pr-1">
                                        <img :src="mainURL + '/img/creditcard/jcb.png'" class="cc-icon__small pr-1">
                                    </div>
                                </div>
                                <input type="text" class="form-control" id="inputNumber" :placeholder="TEXTS.render(`PAYMENT_SECTION_CARD_NUMBER_PLACEHOLDER`)" v-model="paymentDetails.number" @keyup="validateField('number')" maxlength="19">
                                <div class="mt-1 text-danger font-weight-bold" v-html="validations.number.error" />
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="formGroupExampleInput2" class="font-weight-bold" v-html="TEXTS.render(`PAYMENT_SECTION_CARD_EXPIRY_HEADER`)"></label>
                                <input type="text" class="form-control" id="inputExpiryMonth" :placeholder="TEXTS.render(`PAYMENT_SECTION_CARD_EXPIRY_MONTH_PLACEHOLDER`)" v-model="paymentDetails.expiryMonth" @keyup="validateField('expiryMonth')" @change="validateField('expiryMonth')" minlength="2" maxlength="2">
                                <div class="mt-1 text-danger font-weight-bold" v-html="validations.expiryMonth.error" />
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="formGroupExampleInput2" class="font-weight-bold invisible">Expiry Date</label>
                                <input type="text" class="form-control" id="inputExpiryYear" :placeholder="TEXTS.render(`PAYMENT_SECTION_CARD_EXPIRY_YEAR_PLACEHOLDER`)" v-model="paymentDetails.expiryYear" @keyup="validateField('expiryYear')" @change="validateField('expiryYear')" minlength="2" maxlength="2">
                                <div class="mt-1 text-danger font-weight-bold" v-html="validations.expiryYear.error" />
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="formGroupExampleInput2" class="font-weight-bold" v-html="TEXTS.render(`PAYMENT_SECTION_CARD_CVN_HEADER`)"></label>
                                <input type="text" class="form-control" id="inputCvn" :placeholder="TEXTS.render(`PAYMENT_SECTION_CARD_CVN_PLACEHOLDER`)" v-model="paymentDetails.cvn" @keyup="validateField('cvn')" @change="validateField('cvn')" minlength="3" maxlength="4">
                                <div class="mt-1 text-danger font-weight-bold" v-html="validations.cvn.error" />
                            </div>
                        </div>
                    </div>
                    <!-- {{this.validations.valid}}
                    <button type="button" @click="validateAll">Check</button> -->
                </form>
            </div>
            <div class="col-lg-6 mt-3 mt-lg-0">
                <div class="row justify-content-end">
                    <div class="col-12 col-lg-10">
                        <booking-summary-section-two :classes="['summary--section--gray']" />
                    </div>
                </div>
                <div class="row justify-content-end">
                    <div class="col-12 col-lg-10">
                        <booking-summary-section-three :classes="['summary--section--gray']" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="($store.getters.GET_ACTIVE_SERVICE_SETTING && $store.getters.GET_ACTIVE_SERVICE_SETTING.is_paid === isPaid) || hasPaidMultiServiceProducts">
            <div class="col-12">
                <div class="font-weight-bold" v-html="(this.bookingState.endTermsHeader || TEXTS.render(`BOOKING_FORM_END_TERMS_HEADER`))"></div>
                <CheckboxWithLabel
                    @checkboxChange="(checked) => this.acceptedTerms = checked" class="pl-0 pb-2" id="acknowledgeCheckbox" ref="checkboxWithLabel"
                    v-show="this.bookingState.endTermsContent && this.bookingState.endTermsContent !== ''">
                    <span class="pargraph-reduced" v-html="this.bookingState.endTermsContent" />
                </CheckboxWithLabel>
                <CheckboxWithLabel
                    @checkboxChange="(checked) => this.acceptedTerms2 = checked" class="pl-0 pb-2"
                    id="acknowledgeCheckbox2" ref="checkboxWithLabel2"
                    v-show="this.bookingState.endTermsContent2 && this.bookingState.endTermsContent2 !== ''">
                    <span class="pargraph-reduced" v-html="this.bookingState.endTermsContent2" />
                </CheckboxWithLabel>
                <CheckboxWithLabel
                    @checkboxChange="(checked) => this.acceptedTerms3 = checked"
                    class="pl-0 pb-2" id="acknowledgeCheckbox3" ref="checkboxWithLabel3"
                    v-show="this.bookingState.endTermsContent3 && this.bookingState.endTermsContent3 !== ''">
                    <span class="pargraph-reduced" v-html="this.bookingState.endTermsContent3" />
                </CheckboxWithLabel>
                <div class="text-danger font-weight-bold" v-html="validations.endTerms.error" />
            </div>
        </div>
    </div>
</template>

<script>
    // import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import helper from '../../../../helper';
    import BookingSummarySectionTwo from './BookingSummarySectionTwo';
    import BookingSummarySectionThree from './BookingSummarySectionThree';
    import CheckboxWithLabel from '../../../../common/components/CheckboxWithLabel';
    import Texts from '../../../../common/utils/Texts'
    import BookingAcceptedTermsMixin from '../../../../common/mixins/BookingAcceptedTermsMixin';

    export default {
        mixins: [BookingAcceptedTermsMixin],
        props: {
            hasPaidMultiServiceProducts: Boolean
        },
        components: {
            BookingSummarySectionTwo,
            BookingSummarySectionThree,
            CheckboxWithLabel
        },
        computed: {
            TEXTS: () => Texts,
            bookingSubmissionLoading: function() {
                return this.$store.getters.GET_BOOKING_SUBMISSION.loading;
            }
        },
        watch: {
            'bookingSubmissionLoading': function(loading) {
                if (loading) {
                    if ((!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.bookingState.selectedService.is_paid === 2)
                        || (this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.some(product => product.isPaid) )) {
                        this.validateAll();
                    }
                }
            },
        },
        data() {
            return {
                mainURL: process.env.MIX_MAIN_URL,
                isPaid: helper.Payment.Paid,
                validations: {
                    name: {
                        touched: false,
                        error: ''
                    },
                    number: {
                        touched: false,
                        error: ''
                    },
                    expiryMonth: {
                        touched: false,
                        error: ''
                    },
                    expiryYear: {
                        touched: false,
                        error: ''
                    },
                    cvn: {
                        touched: false,
                        error: ''
                    },
                    endTerms: {
                        touched: false,
                        error: ''
                    },
                    valid: true
                },
                paymentDetails: {},
                acknowledgeReceipt: false,
                acceptedTerms: false,
                acceptedTerms2: false,
                acceptedTerms3: false,
                scrollToErrorElement : null
            }
        },
        mounted() {
            // reset store
            this.$store.dispatch('setPaymentInfo', null);
            
            // Mark validation touch to false (in effect: all error message will reset as well)
            this.markAllTouch(false);

            this.setInitialPaymentDetails();
        },
        methods: {
            setInitialPaymentDetails() {
                this.paymentDetails = {
                    name: '',
                    number: '',
                    expiryMonth: '',
                    expiryYear: '',
                    cvn: ''
                };
            },
            acknowledgeReceiptChange() {
                this.$store.dispatch('setAcknowledge', this.acknowledgeReceipt);
            },
            validateField(field) {
                this.validations[field].error = '';
                if (this.paymentDetails[field] && !this.validations[field].touched) {
                    this.validations[field].touched = true;
                }
                if (this.validations[field].touched) {
                    this[`${field}Validate`]();
                }
            },
            numberValidate() {
                if (this.validations.number.touched && (this.paymentDetails.number.length < 12 || this.paymentDetails.number.length > 19 || !/^\d*\d*$/.test(`${this.paymentDetails.number}`))) {
                    this.validations.valid = false;
                    this.validations.number.error = Texts.render(`PAYMENT_SECTION_VALIDATION_CARD_NUMBER`);
                    this.registerScrollToElement("inputNumber")
                }
            },
            cvnValidate() {
                if (this.validations.cvn.touched && (this.paymentDetails.cvn.length < 3 || this.paymentDetails.cvn.length > 4 || !/^\d*\d*$/.test(`${this.paymentDetails.cvn}`))) {
                    this.validations.valid = false;
                    this.validations.cvn.error = Texts.render(`PAYMENT_SECTION_VALIDATION_CARD_CVN`);
                    this.registerScrollToElement("inputCvn")
                }
            },
            nameValidate() {
                if (this.validations.name.touched && (!this.paymentDetails.name.trim() || !(/^[A-Za-z\. _]+$/i.test(this.paymentDetails.name)))) {
                    this.validations.valid = false;
                    this.validations.name.error = Texts.render(`PAYMENT_SECTION_VALIDATION_NAME`);
                    this.registerScrollToElement("inputName")
                }
            },
            expiryMonthValidate() {
                if (this.validations.expiryMonth.touched && (`${this.paymentDetails.expiryMonth}`.trim().length !== 2 || !/^\d*\d*$/.test(`${this.paymentDetails.expiryMonth}`))) {
                    this.validations.valid = false;
                    this.validations.expiryMonth.error = Texts.render(`PAYMENT_SECTION_VALIDATION_CARD_EXPIRY_MONTH`);
                    this.registerScrollToElement("inputExpiryMonth")
                }
            },
            expiryYearValidate() {
                if (this.validations.expiryYear.touched && (`${this.paymentDetails.expiryYear}`.trim().length !== 2 || !/^\d*\d*$/.test(`${this.paymentDetails.expiryYear}`))) {
                    this.validations.valid = false;
                    this.validations.expiryYear.error = Texts.render(`PAYMENT_SECTION_VALIDATION_CARD_EXPIRY_YEAR`);
                    this.registerScrollToElement("inputExpiryYear")
                }
            },
            endTermsValidate() {
                if (this.bookingState.hasEndTerms === 'yes'
                    && this.bookingState.isAgreedToTerms ==='yes'
                    && (
                        (this.bookingState.endTermsContent &&
                            this.bookingState.endTermsContent !== '' &&
                            !this.bookingState.acceptedTerms) ||
                        (this.bookingState.endTermsContent2 &&
                            this.bookingState.endTermsContent2 !== '' &&
                            !this.bookingState.acceptedTerms2) ||
                        (this.bookingState.endTermsContent3 &&
                            this.bookingState.endTermsContent3 !== '' &&
                            !this.bookingState.acceptedTerms3)
                    )
                ) {
                    this.validations.endTerms.error = Texts.render(`PAYMENT_SECTION_VALIDATION_TERMS`);
                    this.registerScrollToElement("acknowledgeCheckbox")
                } else {
                    this.validations.endTerms.error = '';
                }
            },
            markAllTouch(v) {
                for (const key in this.validations) {
                    if (this.validations.hasOwnProperty(key) && key !== 'valid') {
                        this.validations[key].touched = v;
                        if (!v) {
                            this.validations[key].error = '';
                        }
                    }
                }
            },
            // Call this form outside of this component
            validateAll(disableDispatch) {
                if(!this.bookingState.endTermsContent || this.bookingState.endTermsContent === '') {
                    this.acceptedTerms = true;
                }

                if(!this.bookingState.endTermsContent2 || this.bookingState.endTermsContent2 === '') {
                    this.acceptedTerms2 = true;
                }
        
                if(!this.bookingState.endTermsContent3 || this.bookingState.endTermsContent3 === '') {
                    this.acceptedTerms3 = true;
                }
                this.validations.valid = true;
                this.markAllTouch(true);
                this.nameValidate();
                this.numberValidate();
                this.expiryMonthValidate();
                this.expiryYearValidate();
                this.cvnValidate();
                this.endTermsValidate()

                if(!disableDispatch){
                    this.$store.dispatch('setPaymentInfo', { ...this.paymentDetails, valid: this.validations.valid });
                }
                
                // Scroll to if there is an issue
                if(this.scrollToErrorElement){
                    helper.scrollIntoView(this.scrollToErrorElement)
                    this.scrollToErrorElement = null
                }
            },
            registerScrollToElement(element){
                if(typeof element == 'string'){
                    element = document.getElementById(element)
                }

                if(element && !this.scrollToErrorElement){
                    this.scrollToErrorElement = element
                }
            },
            resetForm() {
                this.$store.dispatch('setPaymentInfo', null);
                this.markAllTouch(false);
                this.validations.valid = false;
                // Reset acceptedTerms if exist
                if(this.bookingState.endTermsContent && this.bookingState.endTermsContent !== '')
                    this.acceptedTerms = false;
                if(this.bookingState.endTermsContent2 && this.bookingState.endTermsContent2 !== '')
                    this.acceptedTerms2 = false;
                if(this.bookingState.endTermsContent3 && this.bookingState.endTermsContent3 !== '')
                    this.acceptedTerms3 = false;
                this.setInitialPaymentDetails();

                // Command the acceptance checkbox to clear itself
                this.$refs.checkboxWithLabel && this.$refs.checkboxWithLabel.resetForm();
                this.$refs.checkboxWithLabel2 && this.$refs.checkboxWithLabel2.resetForm();
                this.$refs.checkboxWithLabel3 && this.$refs.checkboxWithLabel3.resetForm();
            }
        },
    }
</script>